import { register } from '../../../JavaScript/Utils'

/* In next refactoring: scope trigger together with content to avoid double content on 1 page */
const AccordionTrigger = el => {
  const accordionId = el.dataset.accordionId
  const accordionTarget = document.querySelector(`[data-accordion-target='${accordionId}']`)
  const accordions = document.querySelectorAll('[data-component="AccordionTrigger"]')
  const accordionTargets = document.querySelectorAll('[data-accordion-target]')
  const closeAll = +el.dataset.closeAll !== 0 // can be done better

  const toggleAccordion = (e) => {
    e.preventDefault()

    if (el.classList.contains('is--active')) {
      el.classList.remove('is--active')
      accordionTarget.classList.remove('is--active')
    } else {
      accordions.forEach(accordion => {
        if (el.dataset.parentAccordionId !== accordion.dataset.accordionId && closeAll) {
          accordion.classList.remove('is--active')
        }
      })
      accordionTargets.forEach(target => {
        if (el.dataset.parentAccordionId !== target.dataset.accordionTarget && closeAll) {
          target.classList.remove('is--active')
        }
      })
      el.classList.add('is--active')
      accordionTarget.classList.add('is--active')
    }
  }

  el.addEventListener('click', toggleAccordion)
}

register('AccordionTrigger', AccordionTrigger)
